import { Copy } from 'lucide-react'
import { toast } from 'sonner'

/** Dark code surface even in light mode (design.md §5.8). */
export function CodeBlock({ code, language }: { code: string; language?: string }) {
  return (
    <div className="group relative rounded-lg bg-ata-grey p-4">
      <button
        aria-label="Copy code"
        onClick={async () => {
          await navigator.clipboard.writeText(code)
          toast.success('Copied to clipboard')
        }}
        className="absolute right-2 top-2 rounded-md p-1.5 text-background/60 opacity-0 transition-opacity hover:bg-background/10 hover:text-background group-hover:opacity-100"
      >
        <Copy className="size-3.5" />
      </button>
      <pre className="overflow-x-auto font-mono text-xs leading-relaxed text-background" data-language={language}>
        <code>{code}</code>
      </pre>
    </div>
  )
}

export function InlineCode({ children }: { children: React.ReactNode }) {
  return <code className="rounded bg-muted px-1.5 py-0.5 font-mono text-xs">{children}</code>
}
